import AddressDTO from "@/dto/AddressDTO";

export default class CreateSublimeOfficeRequest {
    public title: string | null = null;

    public address = new AddressDTO();

    public phone: string | null = null;
}
